import { PurchaseMethods } from '@sm360/widget-commons-vehicle';
import { filter, map, flatten, isArray, sortBy } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';

const { PaymentFrequencies, PaymentFrequencyService } = PurchaseMethods;

export function translateListingUsed(listingUsed) {
    return listingUsed.setIn(
        ['paymentOptions', 'frequencyValues'],
        PaymentFrequencyService.getPaymentFrequencyDropDownValues(LocaleService)
    );
}

export function setPreferredPaymentFrequency(listingUsed, paymentFrequency) {
    const paymentRangeMinEnabled = listingUsed.paymentOptions.range[0] > listingUsed.paymentOptions.rangeBoundaries[0];
    const paymentRangeMaxEnabled = listingUsed.paymentOptions.range[1] < listingUsed.paymentOptions.rangeBoundaries[1];

    let paymentRangeBoundaries;
    let paymentRangeStep;
    switch (paymentFrequency) {
        case PaymentFrequencies.WEEKLY:
            paymentRangeBoundaries = [0, 500];
            paymentRangeStep = 25;
            break;

        case PaymentFrequencies.BI_WEEKLY:
            paymentRangeBoundaries = [0, 1000];
            paymentRangeStep = 50;
            break;

        case PaymentFrequencies.SEMI_MONTHLY:
            paymentRangeBoundaries = [0, 1000];
            paymentRangeStep = 50;
            break;

        case PaymentFrequencies.MONTHLY:
            paymentRangeBoundaries = [0, 2000];
            paymentRangeStep = 100;
            break;

        default:
            paymentRangeBoundaries = [0, 500];
            paymentRangeStep = 25;
            break;
    }

    let paymentRange = listingUsed.paymentOptions.range;
    if (paymentRangeMinEnabled || paymentRangeMaxEnabled) {
        const paymentRangeMin = Math.floor(
            (paymentRange[0] * listingUsed.paymentOptions.preferredPaymentFrequency) / paymentFrequency
        );
        const paymentRangeMax = Math.ceil(
            (paymentRange[1] * listingUsed.paymentOptions.preferredPaymentFrequency) / paymentFrequency
        );

        if (paymentRangeMinEnabled) {
            paymentRange[0] = paymentRangeMin + (paymentRangeMin % 10 > 0 ? (paymentRangeMin % 10) - 10 : 0);
        }
        if (paymentRangeMaxEnabled) {
            paymentRange[1] = paymentRangeMax + (paymentRangeMax % 10 > 0 ? 10 - (paymentRangeMax % 10) : 0);
        }
    } else {
        paymentRange = paymentRangeBoundaries;
    }

    return listingUsed
        .setIn(['paymentOptions', 'preferredPaymentFrequency'], paymentFrequency)
        .setIn(['paymentOptions', 'rangeEnabled'], paymentRangeMinEnabled || paymentRangeMaxEnabled)
        .setIn(['paymentOptions', 'rangeStep'], paymentRangeStep)
        .setIn(['paymentOptions', 'rangeBoundaries'], paymentRangeBoundaries)
        .setIn(['paymentOptions', 'range'], paymentRange);
}

export function addVehicleCriteria(listingUsed, criteria) {
    let currentVehicleCriteria = listingUsed.vehicleCriteria;
    let newCriteria;

    if (isArray(criteria.metadatas)) {
        const filteredMetadatas = filter(criteria.metadatas, (metadata) => {
            return metadata.isSelected;
        });
        newCriteria = flatten(
            map(filteredMetadatas, (metadata) => {
                return metadata.code;
            })
        );
    } else {
        newCriteria = criteria.metadatas;
    }

    currentVehicleCriteria = currentVehicleCriteria.set(criteria.attribute, newCriteria);

    return listingUsed.set('vehicleCriteria', currentVehicleCriteria);
}

export function getFilters(filters, filterName) {
    if (!filterName || !filters.length) {
        return [];
    }

    const metadataCategory = filters.find((metadata) => {
        return metadata.name === filterName;
    });

    if (!metadataCategory) {
        return [];
    }

    return sortBy(metadataCategory.metadatas, ['label']);
}



// WEBPACK FOOTER //
// ./client/src/services/ListingUsedService/ListingUsedService.js